/* tslint:disable:no-forward-ref */

import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, Validator } from '@angular/forms';

import * as Quill from 'quill';
export class NgxQuillEditorComponent implements AfterViewInit, ControlValueAccessor, OnChanges, Validator {
  quillEditor: any
  editorElem: HTMLElement
  emptyArray: any[] = []
  content: any
  defaultModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: this.emptyArray.slice() }, { background: this.emptyArray.slice() }], // dropdown with defaults from theme
      [{ font: this.emptyArray.slice() }],
      [{ align: this.emptyArray.slice() }],

      ['clean'], // remove formatting button

      ['link', 'image', 'video'], // link and image, video
    ],
  }

   theme: string
   modules: { [index: string]: Object }
   readOnly: boolean
   placeholder: string
   maxLength: number
   minLength: number
   required: boolean
   formats: string[]
   bounds: HTMLElement | string

   onEditorCreated: EventEmitter<any> = new EventEmitter()
   onContentChanged: EventEmitter<any> = new EventEmitter()
   onSelectionChanged: EventEmitter<any> = new EventEmitter()

  onModelChange: Function = () => {}
  onModelTouched: Function = () => {}
/**
 * @param {?} elementRef
 */
constructor(private elementRef: ElementRef) {}
/**
 * @return {?}
 */
ngAfterViewInit() {
    const /** @type {?} */ toolbarElem = this.elementRef.nativeElement.querySelector('[quill-editor-toolbar]')
    const /** @type {?} */ modules: any = this.modules || this.defaultModules
    let /** @type {?} */ placeholder = 'Insert text here ...'

    if (this.placeholder !== null && this.placeholder !== undefined) {
      placeholder = this.placeholder.trim()
    }

    if (toolbarElem) {
      modules['toolbar'] = toolbarElem
    }
    this.elementRef.nativeElement.insertAdjacentHTML('beforeend', '<div quill-editor-element></div>')
    this.editorElem = this.elementRef.nativeElement.querySelector('[quill-editor-element]')

    this.quillEditor = new Quill(this.editorElem, {
      modules: modules,
      placeholder: placeholder,
      readOnly: this.readOnly || false,
      theme: this.theme || 'snow',
      formats: this.formats,
      bounds: this.bounds || document.body,
    })

    if (this.content) {
      const /** @type {?} */ contents = this.quillEditor.clipboard.convert(this.content)
      this.quillEditor.setContents(contents)
      this.quillEditor.history.clear()
    }

    this.onEditorCreated.emit(this.quillEditor)

    // mark model as touched if editor lost focus
    this.quillEditor.on('selection-change', (range: any, oldRange: any, source: string) => {
      this.onSelectionChanged.emit({
        editor: this.quillEditor,
        range: range,
        oldRange: oldRange,
        source: source,
      })

      if (!range) {
        this.onModelTouched()
      }
    })

    // update model if text changes
    this.quillEditor.on('text-change', (delta: any, oldDelta: any, source: string) => {
      let /** @type {?} */ html: string | null = this.editorElem.children[0].innerHTML
      const /** @type {?} */ text = this.quillEditor.getText()

      if (html === '<p><br></p>') {
        html = null
      }

      this.onModelChange(html)

      this.onContentChanged.emit({
        editor: this.quillEditor,
        html: html,
        text: text,
        delta: delta,
        oldDelta: oldDelta,
        source: source,
      })
    })
  }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    if (changes['readOnly'] && this.quillEditor) {
      this.quillEditor.enable(!changes['readOnly'].currentValue)
    }
  }
/**
 * @param {?} currentValue
 * @return {?}
 */
writeValue(currentValue: any) {
    this.content = currentValue

    if (this.quillEditor) {
      if (currentValue) {
        this.quillEditor.setContents(this.quillEditor.clipboard.convert(this.content))
        return
      }
      this.quillEditor.setText('')
    }
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: Function): void {
    this.onModelChange = fn
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: Function): void {
    this.onModelTouched = fn
  }
/**
 * @return {?}
 */
validate() {
    if (!this.quillEditor) {
      return null
    }

    let /** @type {?} */ valid = true

    const /** @type {?} */ err: {
      minLengthError?: { given: number; minLength: number }
      maxLengthError?: { given: number; maxLength: number }
      requiredError?: { empty: boolean }
    } = {}

    const /** @type {?} */ textLength = this.quillEditor.getText().trim().length

    if (this.minLength && textLength && textLength < this.minLength) {
      err.minLengthError = {
        given: textLength,
        minLength: this.minLength,
      }

      valid = false
    }

    if (this.maxLength && textLength > this.maxLength) {
      err.maxLengthError = {
        given: textLength,
        maxLength: this.maxLength,
      }

      valid = false
    }

    if (this.required && !textLength) {
      err.requiredError = {
        empty: true,
      }

      valid = false
    }

    return valid ? null : err
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-quill-editor',
  template: `
  <ng-content select="[quill-editor-toolbar]"></ng-content>
`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxQuillEditorComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NgxQuillEditorComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'theme': [{ type: Input },],
'modules': [{ type: Input },],
'readOnly': [{ type: Input },],
'placeholder': [{ type: Input },],
'maxLength': [{ type: Input },],
'minLength': [{ type: Input },],
'required': [{ type: Input },],
'formats': [{ type: Input },],
'bounds': [{ type: Input },],
'onEditorCreated': [{ type: Output },],
'onContentChanged': [{ type: Output },],
'onSelectionChanged': [{ type: Output },],
};
}

function NgxQuillEditorComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxQuillEditorComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxQuillEditorComponent.ctorParameters;
/** @type {?} */
NgxQuillEditorComponent.propDecorators;
/** @type {?} */
NgxQuillEditorComponent.prototype.quillEditor;
/** @type {?} */
NgxQuillEditorComponent.prototype.editorElem;
/** @type {?} */
NgxQuillEditorComponent.prototype.emptyArray;
/** @type {?} */
NgxQuillEditorComponent.prototype.content;
/** @type {?} */
NgxQuillEditorComponent.prototype.defaultModules;
/** @type {?} */
NgxQuillEditorComponent.prototype.theme;
/** @type {?} */
NgxQuillEditorComponent.prototype.modules;
/** @type {?} */
NgxQuillEditorComponent.prototype.readOnly;
/** @type {?} */
NgxQuillEditorComponent.prototype.placeholder;
/** @type {?} */
NgxQuillEditorComponent.prototype.maxLength;
/** @type {?} */
NgxQuillEditorComponent.prototype.minLength;
/** @type {?} */
NgxQuillEditorComponent.prototype.required;
/** @type {?} */
NgxQuillEditorComponent.prototype.formats;
/** @type {?} */
NgxQuillEditorComponent.prototype.bounds;
/** @type {?} */
NgxQuillEditorComponent.prototype.onEditorCreated;
/** @type {?} */
NgxQuillEditorComponent.prototype.onContentChanged;
/** @type {?} */
NgxQuillEditorComponent.prototype.onSelectionChanged;
/** @type {?} */
NgxQuillEditorComponent.prototype.onModelChange;
/** @type {?} */
NgxQuillEditorComponent.prototype.onModelTouched;
/** @type {?} */
NgxQuillEditorComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
